import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemText,
  MenuItem,
  Popper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import {
  CmpSelectField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import {
  common_brandbasedgroup_GETROW,
  common_brandgroup_GETROW,
  common_groupstructure_GETROW,
  common_VendorListReport_GETROW,
} from "../../../Server/ApiV2";
import axios from "axios";
import { getGlobals } from "../../../Configs";
import GCAutocompleteCheckboxFixSize from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckboxFixSize";
import GCSupplierSearch from "../../../Component/Common/ReuseableComponent/GCSupplierSearch";
import GCBrandSearch from "../../../Component/Common/ReuseableComponent/GCBrandSearch";
const MasterModal = ({ vMediaQuery, xMediaQuery, loc, onClickSave }) => {
  const baseURL = getGlobals().API_BASE_URL;
  const sWebStockReportData = [
    { Uid: "All", Value: "ALL" },
    { Uid: "Is", Value: "Is" },
  ];

  const [sMainGroupData, setMainGroupData] = useState([]);
  const [sCategoryData, setCategoryData] = useState([]);
  const [sSubGroupData, setSubGroupData] = useState([]);
  const [sMainSupplierData, setMainSupplierData] = useState([]);
  const [sBrandData, setBrandData] = useState([]);
  const [sBrandCategoryData, setBrandCategoryData] = useState([]);
  const [itemGetRowData, setItemGetRowData] = useState([]);
  const [deleteInsert, setDeleteInsert] = useState("N");
  const [selectedRows, setSelectedRows] = useState([]);
  const HeadObjectInit = {
    // sLocation: "Is",
    sMainGroup: "All",
    sSubGroup: "All",
    sCategory: "All",
    sMainSupplier: "All",
    sBrand: "All",

    sLocationArr: [],
    sLocationPrnt: "",
    sLocationCode: "",
    sLocationName: "",
    sMainGroupArr: [],
    sMainGroupPrnt: "",
    sMainGroupCode: "",
    sMainGroupName: "",
    sSubGroupArr: [],
    sSubGroupPrnt: "",
    sSubGroupCode: "",
    sSubGroupName: "",
    sCategoryArr: [],
    sCategoryPrnt: "",
    sCategoryCode: "",
    sCategoryName: "",
    sMainSupplierArr: [],
    sMainSupplierPrnt: "",
    sMainSupplierCode: "",
    sMainSupplierName: "",
    sSupplierSearchValue: "",
    sBrandArr: [],
    sBrandPrnt: "",
    sBrandCode: "",
    sBrandName: "",
    sBrandCategoryArr: [],
    sBrandCategoryPrnt: "",
    sBrandCategoryCode: "",
    sBrandCategoryName: "",
    sBrandSearchValue: "",
  };
  const [masterData, setMasterData] = useState(HeadObjectInit);

  const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
    let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
    const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fMainGroup = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      sMainGroup: e.target.value,
      sMainGroupArr: [],
      sMainGroupPrnt: "",
      sMainGroupName: "",
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);

    if (e.target.value.toUpperCase() == "ALL") {
      setMainGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj = {
        Prnt: "",
        Lvl: "1",
      };
      await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
    }
  };

  const fSubGroup = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    setCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setSubGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      const mainGrpData = masterData?.sMainGroupArr
        .map((item) => `${item}`)
        .join(",");
      let xGroupStructureObj2 = {
        Prnt: mainGrpData,
        Lvl: "2",
      };
      await fWmsStockRepotArr(xGroupStructureObj2, setSubGroupData);
    }
  };

  // const fSubGroup_MultiSelect = (value) => {
  //   let currentPrnt = value.map((option) => option.Cd).join(",");
  //   let currentName = value.map((option) => option.Name1).join(",");
  //   setMasterData((obj) => ({
  //     ...obj,
  //     sSubGroupArr: value,
  //     sSubGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
  //     sSubGroupName: value?.length <= 0 ? "" : currentName,
  //   }));
  //   fSubGroup_Focus();
  // };

  // const fSubGroup_Focus = (value) => {
  //   setMasterData((obj) => ({
  //     ...obj,
  //     sCategory: "All",
  //     sCategoryArr: [],
  //     sCategoryPrnt: "",
  //     sCategoryName: "",
  //   }));
  //   setCategoryData([]);
  // };

  const fCategory = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    if (e.target.value.toUpperCase() == "ALL") {
      setCategoryData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      const subGrpData = masterData?.sSubGroupArr
        .map((item) => `${item}`)
        .join(",");
      let xGroupStructureObj2 = {
        Prnt: subGrpData,
        Lvl: "3",
      };

      await fWmsStockRepotArr(xGroupStructureObj2, setCategoryData);
    }
  };

  // const fCategory_MultiSelect = (value) => {
  //   let currentPrnt = value.map((option) => option.Cd).join(",");
  //   let currentName = value.map((option) => option.Name1).join(",");
  //   setMasterData((obj) => ({
  //     ...obj,
  //     sCategoryArr: value,
  //     sCategoryPrnt: value?.length <= 0 ? "" : currentPrnt,
  //     sCategoryName: value?.length <= 0 ? "" : currentName,
  //   }));
  //   fCategory_Focus();
  // };

  const GetWmsStockRepotMainSupplier = async (setGroupData) => {
    const CurrentMaingroupArr = await common_VendorListReport_GETROW("");
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fMainSupplier = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sMainSupplierArr: [],
      sMainSupplierPrnt: "",
      sMainSupplierName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setMainSupplierData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotMainSupplier(setMainSupplierData);
    }
  };

  // const fMainSupplier_MultiSelect = async (value) => {
  //   let currentPrnt = value.map((option) => option.Cd).join(",");
  //   let currentName = value.map((option) => option.Name1).join(",");
  //   setMasterData((obj) => ({
  //     ...obj,
  //     sMainSupplierArr: value,
  //     sMainSupplierPrnt: value?.length <= 0 ? "" : currentPrnt,
  //     sMainSupplierName: value?.length <= 0 ? "" : currentName,
  //   }));
  // };

  const GetWmsStockRepotBrand = async (setGroupData) => {
    const CurrentMaingroupArr = await common_brandgroup_GETROW("");
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };
  const fBrand = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sBrandArr: [],
      sBrandPrnt: "",
      sBrandName: "",
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
    setBrandCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setBrandData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotBrand(setBrandData);
    }
  };

  // const fWmsStockRepotBrandArr = async (xGroupStructureObj, setGroupData) => {
  //   let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  //   const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
  //   if (CurrentMaingroupArr?.status === 200) {
  //     setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  //   }
  // };

  // const fBrand_MultiSelect = async (value) => {
  //   let currentPrnt = value.map((option) => option.Cd).join(",");
  //   let currentName = value.map((option) => option.Name1).join(",");
  //   setMasterData((obj) => ({
  //     ...obj,
  //     sBrandArr: value,
  //     sBrandPrnt: value?.length <= 0 ? "" : currentPrnt,
  //     sBrandName: value?.length <= 0 ? "" : currentName,
  //   }));
  //   let xGroupStructureObj = {
  //     grp: value?.length <= 0 ? "" : currentPrnt,
  //   };
  //   await fWmsStockRepotBrandArr(xGroupStructureObj, setBrandCategoryData);
  //   fBrand_Focus();
  // };

  // const fBrand_Focus = (value) => {
  //   setMasterData((obj) => ({
  //     ...obj,
  //     sBrandCategoryArr: [],
  //     sBrandCategoryPrnt: "",
  //     sBrandCategoryCode: "",
  //     sBrandCategoryName: "",
  //   }));
  // };

  // const fBrandCategory_MultiSelect = (value) => {
  //   let currentPrnt = value.map((option) => option.Cd).join(",");
  //   let currentName = value.map((option) => option.Name1).join(",");
  //   setMasterData((obj) => ({
  //     ...obj,
  //     sBrandCategoryArr: value,
  //     sBrandCategoryPrnt: value?.length <= 0 ? "" : currentPrnt,
  //     sBrandCategoryName: value?.length <= 0 ? "" : currentName,
  //   }));
  // };

  const fLoad = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    const mainGrpData = masterData?.sMainGroupArr
      .map((item) => `${item}`)
      .join(",");
    const subGrpData = masterData?.sSubGroupArr
      .map((item) => `${item}`)
      .join(",");
    const catGrpData = masterData?.sCategoryArr
      .map((item) => `${item}`)
      .join(",");
    const suplGrpData = masterData?.sMainSupplierArr
      .map((x) => x.AcCd)
      .join(",");
      const brandGrpData = masterData?.sBrandArr.map((x) => x.UID).join(",");
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/CyclicCountItemsMaster`,
        fcheck_null_undefine_replace_empty({
          v_MainGrp: mainGrpData,
          v_SubGrp: subGrpData,
          v_Grp: catGrpData,
          v_BrandCd: brandGrpData,
          v_Supplier: suplGrpData,
          v_Loc: loc,
        })
      );
      if (response?.status === 200) {
        loader.style.display = "none";
        setItemGetRowData(response?.data?.ResultSet);
      }
    } catch (error) {
      loader.style.display = "none";
    }
  };
  console.log("masterData", itemGetRowData);

  const handleSelectionChange = (selectedIds) => {
    if (!itemGetRowData) return;
    // Find the full object for each selected ID
    const selectedObjects = itemGetRowData?.filter((row) =>
      selectedIds.includes(row.ItmCd)
    );

    // Update state with full row data
    setSelectedRows(selectedObjects);
  };
  console.log("selectedRows", selectedRows);
  const fSave = () => {
    let iArray = selectedRows?.map((obj) => ({
      P_ItmCd: obj.ItmCd,
      P_B_CancelledQty: 0,
      P_B_VoidQty: 0,
      P_B_ReturnQt: 0,
      P_B_AdjustQty: 0,
      P_B_PurchaseReturnQty: 0,
      P_B_SrQty: 0,
    }));

    console.log("iArray", iArray);

    onClickSave(iArray, deleteInsert);
  };

  // useEffect(() => {
  //   if (masterData.sBrandArr.length > 0) {
  //     fetchBrandCategory();
  //   }
  // }, [masterData.sBrandArr]);

  useEffect(() => {
    setMasterData((prev) => ({
      ...prev,
      sSubGroup: "All",
      sSubGroupArr: [],
    }));
  }, [masterData.sMainGroupArr]);

  useEffect(() => {
    setMasterData((prev) => ({
      ...prev,
      sCategory: "All",
      sCategoryArr: [],
    }));
  }, [masterData.sSubGroupArr]);

  // const fetchBrandCategory = async () => {
  //   const subGrpData = masterData?.sBrandArr.map((item) => `${item}`).join(",");
  //   let xGroupStructureObj = {
  //     grp: subGrpData,
  //   };
  //   await fWmsStockRepotBrandArr(xGroupStructureObj, setBrandCategoryData);
  // };

  return (
    <Box sx={{ paddingY: 1, paddingX: 0 }}>
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0.5, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Main Group"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"03"}
                xLabelText="sMainGroup"
                xValue={masterData.sMainGroup}
                xOnChange={fMainGroup}
                xName={"sMainGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={9.2} lg={9.7}>
              <GCAutocompleteCheckboxFixSize
                options={sMainGroupData}
                xValue={masterData.sMainGroupArr}
                xtabIndex={"04"}
                xDisabled={
                  masterData?.sMainGroup?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sMainGroupArr"
                label=""
                placeholder="Search Main Group"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Sub Group"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"05"}
                xLabelText="sSubGroup"
                xValue={masterData.sSubGroup}
                xOnChange={fSubGroup}
                xName={"sSubGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={9.2} lg={9.7}>
              <GCAutocompleteCheckboxFixSize
                options={sSubGroupData}
                xValue={masterData.sSubGroupArr}
                xtabIndex={"06"}
                xDisabled={
                  masterData?.sSubGroup?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sSubGroupArr"
                label=""
                placeholder="Search Sub Group"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Category"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"07"}
                xLabelText="sCategory"
                xValue={masterData.sCategory}
                xOnChange={fCategory}
                xName={"sCategory"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={9.2} lg={9.7}>
              <GCAutocompleteCheckboxFixSize
                options={sCategoryData}
                xValue={masterData.sCategoryArr}
                xtabIndex={"08"}
                xDisabled={
                  masterData?.sCategory?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sCategoryArr"
                label=""
                placeholder="Search Category"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Supplier"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sMainSupplier"
                xValue={masterData.sMainSupplier}
                xOnChange={fMainSupplier}
                xName={"sMainSupplier"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={9.2} lg={9.7}>
              {/* <GCAutocompleteCheckboxFixSize
                options={sMainSupplierData}
                xValue={masterData.sMainSupplierArr}
                xtabIndex={"10"}
                xDisabled={
                  masterData?.sMainSupplier?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                setValue={setMasterData}
                objName="sMainSupplierArr"
                label=""
                placeholder="Search Supplier"
              /> */}
              <GCSupplierSearch
                xValue={masterData.sSupplierSearchValue} //main input value
                xOnChange={(e) => {
                  setMasterData((obj) => ({
                    ...obj,
                    sSupplierSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  masterData?.sMainSupplier?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                basketValue={masterData?.sMainSupplierArr} //Search basket array
                xListValue={masterData?.sMainSupplierArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  setMasterData((obj) => ({
                    ...obj,
                    sMainSupplierArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Brand"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"11"}
                xLabelText="sBrand"
                xValue={masterData.sBrand}
                xOnChange={fBrand}
                xName={"sBrand"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            {/* <Grid item xs={7.5} sm={4} md={4.5} lg={5}>
              <GCAutocompleteCheckboxFixSize
                options={sBrandData}
                xValue={masterData.sBrandArr}
                xtabIndex={"12"}
                xDisabled={
                  masterData?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sBrandArr"
                label=""
                placeholder="Search Brand"
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4.7} lg={4.7}>
              <GCAutocompleteCheckboxFixSize
                options={sBrandCategoryData}
                xValue={masterData.sBrandCategoryArr}
                xtabIndex={"13"}
                xDisabled={
                  masterData?.sBrand?.toUpperCase() === "ALL" ||
                  masterData.sBrandArr.length === 0
                    ? true
                    : false
                }
                setValue={setMasterData}
                objName="sBrandCategoryArr"
                label=""
                placeholder="Search Brand Category"
              />
            </Grid> */}
            <Grid item xs={7.5} sm={8} md={9.2} lg={10}>
              <GCBrandSearch
                xValue={masterData?.sBrandSearchValue} //main input value
                xOnChange={(e) => {
                  setMasterData((obj) => ({
                    ...obj,
                    // sBrandArr: e.target.value,
                    sBrandSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  masterData?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                basketValue={masterData?.sBrandArr} //Search basket array
                xListValue={masterData?.sBrandArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  console.log("selectedObjects", selectedObjects);
                  setMasterData((obj) => ({
                    ...obj,
                    sBrandArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container textAlign={"center"} marginTop={vMediaQuery ? 1 : 0}>
        <Grid item xs={4}>
          <Button
            variant="contained"
            sx={{
              height: "30px",
              width: vMediaQuery ? "" : "120px",
              mt: vMediaQuery ? 0 : 1,
              mr: 1,
              textTransform: "capitalize",
            }}
            onClick={() => {
              fLoad();
            }}
          >
            Load
          </Button>
        </Grid>

        <Grid item xs={5} textAlign={"end"} marginTop={vMediaQuery ? 0.5 : 0.5}>
          <FormControlLabel
            sx={{
              "& .MuiCheckbox-root": {
                padding: vMediaQuery ? "0px !important" : "7px !important",
              },
            }}
            control={
              <Checkbox
                checked={deleteInsert === "Y"}
                onChange={(event) => {
                  setDeleteInsert(event.target.checked ? "Y" : "N");
                }}
                name="deleteInsert"
              />
            }
            label="Delete & Insert"
          />
        </Grid>
        <Grid item xs={3} textAlign={"start"}>
          <Button
            variant="contained"
            sx={{
              height: "30px",
              width: vMediaQuery ? "" : "120px",
              mt: vMediaQuery ? 0 : 1,
              mr: 1,
              textTransform: "capitalize",
            }}
            onClick={() => {
              if (itemGetRowData?.length > 0) {
                fSave();
              } else {
                fAlertToast("FAILED", "Grid should not be empty");
              }
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          height: vMediaQuery ? "65vh" : "57vh",
          width: "100%",
        }}
      >
        <DataGrid
          rowHeight={30}
          headerHeight={40}
          components={{
            Toolbar: GridToolbar,
          }}
          rows={itemGetRowData ? itemGetRowData : ""}
          getRowId={(v) => v.ItmCd}
          columns={[
            {
              field: "ItmCd",
              headerName: "Item Code",
              width: xMediaQuery ? 100 : 110,
            },
            {
              field: "ItemName",
              headerName: "Item Name",
              width: xMediaQuery ? 250 : 350,
            },
            {
              field: "Category",
              headerName: "Category",
              width: xMediaQuery ? 150 : 110,
            },
            {
              field: "Brand",
              headerName: "Brand",
              width: xMediaQuery ? 150 : 130,
            },
            {
              field: "Vendor",
              headerName: "Vendor",
              width: xMediaQuery ? 250 : 300,
            },
          ]}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
          }}
          hideFooter={itemGetRowData?.length < 100}
          // onRowClick={(params) => handleRowClick(params.row)}
          checkboxSelection // Enables checkboxes
          disableSelectionOnClick // Prevents row selection when clicking inside a row
          onSelectionModelChange={handleSelectionChange}
        />
      </Box>
    </Box>
  );
};

export default MasterModal;
